import React, { useEffect, useState, Fragment } from "react";
import { Pagination, PageHeader, paginate } from "../../../Common";
import { IgnoreSessionTableContent } from "../../Common/Table/tableContent";
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import services from "../services";
import { search, SearchFeild } from "../../Common";
import MenuItem from "@material-ui/core/MenuItem";
import $, { data } from "jquery";
import { ignoreSessionSchemaObject } from "../ignoreSessionSchema";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import Joi, { x } from "@hapi/joi";
import { TextField } from "@material-ui/core";
import FileBase64 from "react-file-base64";
import FormHelperText from "@material-ui/core/FormHelperText";
import authService from "../../Common/services";
import tokenService from "../../../Common/tokenDecoder";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import DoneIcon from '@material-ui/icons/Done';

const screenCode = "IGNORESESSION";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export function Listing(props) {
  const classes = useStyles();
  const [ignoreSession, setIgnoreSession] = useState({
    data: []
  });
  const [ignoreSessionSearch, setIgnoreSessionSearch] = useState({
    groupID: 0,
    operationEntityID: 0,
    collectionPointID: 0,
    fieldID: 0,
    statusID: 1
  });
  const [rejectData, setRejectData] = useState({
    ignoreSessionEmployeeID: "",
    rejectReason: "",
  });
  const [groups, setGroups] = useState();
  const [estates, setEstates] = useState();
  const [devisions, setDevisions] = useState();
  const [fields, setFeilds] = useState();
  const [isTableHide, setIsTableHide] = useState(true);
  const contentRowNames = ["registrationNumber", "searchDate", "requestReason"];
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const [open, setOpen] = React.useState(false);
  const [openReject, setOpenReject] = React.useState(false);
  const schema = Joi.object(ignoreSessionSchemaObject).options({
    allowUnknown: true,
  });
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Save/ Edit success"
  })



  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    trackPromise(getEstates());
  }, [ignoreSessionSearch.groupID]);

  useEffect(() => {
    trackPromise(getDevisions());
  }, [ignoreSessionSearch.operationEntityID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find(
      (p) => p.permissionCode == "VIEWIGNORESESSION"
    );
    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }

    var isAddEditEnabled = permissions.find(
      (p) => p.permissionCode == "ADDEDITIGNORESESSION"
    );
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isAddEditEnabled: isAddEditEnabled !== undefined,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled:
        isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();
    setIgnoreSessionSearch({
      ...ignoreSessionSearch,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });
    getAllGroups();
  }
  async function getDevisions() {
    const result = await services.getDivisions(
      ignoreSessionSearch.operationEntityID
    );
    setDevisions(result);
  }
  async function getEstates() {
    var data = await services.getEstatesByGroupID(ignoreSessionSearch.groupID);
    setEstates(data);
  }

  async function getAllGroups() {
    const result = await services.getGroups();
    setGroups(result);
  }

  async function handleApprove1(e) {
    e.preventDefault()

    const response = await services.IgnoreSessionStatusUpdate(fields)
    setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
    afterSuccessfulyChanged(response.statusCode)
    setOpen(false);

  }

  async function handleReject1(e) {
    e.preventDefault()

    const errorMessages = validate(schema, ignoreSession.data)
    errorMessages !== null ? setErrors(errorMessages) : setErrors({})

    if (rejectData.rejectReason !== "") {
      const response = await services.IgnoreSessionRejectStatusUpdate(rejectData)
      setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
      afterSuccessfulyChanged(response.statusCode)
      setOpenReject(false);
    }
    else {
      setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Reason Required" })
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true })
      }, 1500);
    }
  }

  function afterSuccessfulyChanged(response) {
    if (response === "Success") {
      clearState()
    }
  }

  function destroyDataTable() {
    $("#example").DataTable().destroy();
  }

  function createDataTable() {
    $("#example").DataTable();
  }

  function handleReject(ignoreSession) {
    props.history.push({
      pathname: setOpenReject(true),
      data: ignoreSession,
      edit: true,
    });
    setRejectData({
      ...rejectData,
      ignoreSessionEmployeeID: ignoreSession.ignoreSessionEmployeeID
    });
  }

  function handleApprove(ignoreSession) {
    props.history.push({
      pathname: setOpen(true),
      data: ignoreSession,
      edit: true,
    });
    setFeilds(ignoreSession)
  }


  function handleClick(ignoreSession) {
    props.history.push({
      pathname: "ignoreSession/addEdit",
      data: ignoreSession,
      edit: true,
    });
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }
  async function getIgnoreSession(collectionPointID, statusID) {
    const data = await services.getAllIgnoreSessionByFilter(collectionPointID, statusID);
    return data;
  }

  async function handleSearch() {
    if (ignoreSessionSearch.collectionPointID != 0) {
      var data = await getIgnoreSession(ignoreSessionSearch.collectionPointID, ignoreSessionSearch.statusID);
      if (data !== []) {
        setIsTableHide(false);
      }
      data.forEach((x) => {
        x.searchDate = x.searchDate.split("T")[0];
      });

      setIgnoreSession({
        data: data
      });
    }
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setIgnoreSessionSearch({
      ...ignoreSessionSearch,
      groupID: target.value,
      operationEntityID: "0",
      collectionPointID: "0",
    });
  }

  function handleEstateChange(target) {
    validateInputs(target);
    setIgnoreSessionSearch({
      ...ignoreSessionSearch,
      operationEntityID: target.value,
      collectionPointID: "0",
    });
  }
  function handleDivisionChange(target) {
    validateInputs(target);
    setIgnoreSessionSearch({
      ...ignoreSessionSearch,
      collectionPointID: target.value,
    });
  }
  function handleStatusChange(target) {
    setIgnoreSession({
      data: []
    });
    validateInputs(target);
    setIgnoreSessionSearch({
      ...ignoreSessionSearch,
      statusID: target.value,
    });
  }


  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, ignoreSessionSchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }

  function handleChange(e) {
    const target = e.target
    const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value

    const error = { ...errors }
    const errorMessage = validateProperty(target, ignoreSessionSchemaObject)
    errorMessage ? error[target.name] = errorMessage : delete error[target.name]


    setRejectData({
      ...rejectData,
      [e.target.name]: value
    })

    setErrors(error)
  }

  function clearState() {
    var token = tokenService.getUserDetailsFromToken();
    setIgnoreSessionSearch({
      ...ignoreSessionSearch,
      groupID: !permissionList.isGroupFilterEnabled ? "0" : token.groupID,
      operationEntityID: !permissionList.isOperationEntityFilterEnabled
        ? "0"
        : token.operationEntityID,
      collectionPointID: "0",
    });
    destroyDataTable();
    setIgnoreSession({
      data: []
    });
    setIsTableHide(true);
  }

  function onCancelClick() {
    setErrors({});
    clearState();
  }


  function handleClickOpen() {
    setOpen(true);
  }

  function handleClickOpen2() {
    setOpenReject(true);
  }

  function handleClose() {
    setOpen(false);
  }

  function handleClose2() {
    setOpenReject(false);
  }



  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <PageHeader
                  title="Ignore Session"
                  isButtonEnable={true}
                  buttonText="Add ignoreSession Details"
                  path="ignoreSession/addEdit"
                />
              </div>
              <hr />

              <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="groupID"
                      disabled={!permissionList.isGroupFilterEnabled}
                      name="groupID"
                      value={ignoreSessionSearch.groupID}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["groupID"]}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Estate *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="operationEntityID"
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      name="operationEntityID"
                      value={ignoreSessionSearch.operationEntityID}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Estate--</MenuItem>
                      {generateDropDownMenu(estates)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="collectionPointID">
                      Division *
                    </InputLabel>
                    <Select
                      fullWidth
                      id="collectionPointID"
                      name="collectionPointID"
                      value={ignoreSessionSearch.collectionPointID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Division--</MenuItem>
                      {generateDropDownMenu(devisions)}
                    </Select>
                    {errors["collectionPointID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["collectionPointID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md">
                    <TextField select fullWidth
                      label="Status "
                      id="statusID"
                      name="statusID"
                      value={ignoreSessionSearch.statusID}
                      type="text"
                      onChange={(e) => handleStatusChange(e.target)}>
                      <option value="1">New</option>
                      <option value="2">Approved</option>
                      <option value="3">Rejected</option>
                    </TextField>
                  </div>
                </div>
                <div className="form-group row">
                </div>
                <div className="card-footer">
                  <input
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => handleSearch(e)}
                  />
                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" style={{ fontWeight: "bold" }}>Registration</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold" }}>Effective Date</TableCell>
                      <TableCell align="center" style={{ fontWeight: "bold" }}>Reason</TableCell>
                      {permissionList.isAddEditEnabled && ignoreSessionSearch.statusID == 1 ? <TableCell align="center" style={{ fontWeight: "bold" }}>Reject</TableCell> : null}
                      {permissionList.isAddEditEnabled && ignoreSessionSearch.statusID == 1 ? (<TableCell align="center" style={{ fontWeight: "bold" }}>Approve</TableCell>) : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ignoreSession.data.map((row) => (
                      <TableRow key={row.registrationNumber}>
                        <TableCell align="center">{row.registrationNumber}</TableCell>
                        <TableCell align="center">{row.searchDate}</TableCell>
                        <TableCell align="center">{row.requestReason}</TableCell>
                        {permissionList.isAddEditEnabled && ignoreSessionSearch.statusID == 1 ? <TableCell align="center"><IconButton aria-label="done"><CancelIcon fontSize="small" onClick={() => handleReject(row)} /></IconButton></TableCell> : null}
                        {permissionList.isAddEditEnabled && ignoreSessionSearch.statusID == 1 ? <TableCell align="center"><IconButton aria-label="delete"><DoneIcon fontSize="small" onClick={() => handleApprove(row)} /></IconButton></TableCell> : null}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClickOpen}
                  hidden={true}
                >
                  Open alert dialog
                </Button>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{"Approve"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure you want to Approve this record?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      No
                    </Button>
                    <Button onClick={handleApprove1} color="primary" autoFocus>
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleClickOpen2}
                  hidden={true}
                >
                  Open form dialog
                </Button>
                <Dialog
                  open={openReject}
                  onClose={handleClose2}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">Reject</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Are you sure you want to Reject this record?
                    </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="rejectReason"
                      name="rejectReason"
                      value={rejectData.rejectReason}
                      label="Reject Reason"
                      onChange={(e) => handleChange(e)}
                      type="text"
                      fullWidth
                    />
                    {errors["rejectReason"] && <span id="errbranchCode" className="text text-danger">{errors["rejectReason"]}</span>}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose2} color="primary">
                      No
                    </Button>
                    <Button onClick={handleReject1} color="primary">
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
